@if (httpError == '404') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.administration.batch.shared.errors.not-found' | translate }}
	</mat-error>
}
@if (httpError == '500') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.administration.batch.shared.errors.internal-server-error' | translate }}
	</mat-error>
}

<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.administration.batch.delete.heading' | translate }}
</h1>
<div mat-dialog-content>
	<p>{{ 'mes.administration.batch.delete.content' | translate: { alias: item.alias } }}</p>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'mes.administration.batch.shared.okbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'mes.administration.batch.shared.cancelbtn' | translate }}
	</button>
</div>
